<div class="flex w-full h-screen items-center flex-col justify-center">
    <div class="ping"></div>
    <h2 class="text-primary text-[24px] mt-4 font-semibold font-roboto">LOADING...</h2>
</div>